(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-storage-wager.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-storage-wager.js');
"use strict";


const {
  useEffect
} = React;
const {
  useSetAtom,
  useAtomValue
} = jotai;
const {
  pinLocationTypeAtom,
  locationConfirmedAtom,
  lyckoplatsenNameAtom,
  pinLocationAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  activeCharitiesAtom,
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;

function useStorageWager() {
  const setLocationType = useSetAtom(pinLocationTypeAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const setLyckoplatsenName = useSetAtom(lyckoplatsenNameAtom);
  const activeCharities = useAtomValue(activeCharitiesAtom);
  const setCharity = useSetAtom(charityAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  useEffect(() => {
    var _svs$components$Stora, _svs$components$Stora2;
    const {
      wagers
    } = (_svs$components$Stora = (_svs$components$Stora2 = svs.components.Storage.browser.get('start', 'subscription')) === null || _svs$components$Stora2 === void 0 ? void 0 : _svs$components$Stora2.entry) !== null && _svs$components$Stora !== void 0 ? _svs$components$Stora : {};
    if (Array.isArray(wagers) && wagers.length) {
      const {
        geoLoc,
        geoLocName,
        geoLocType,
        charityId
      } = wagers[0].bets[0].geoBoardData;
      const lat = Number(parseFloat(geoLoc.latitude.replace(',', '.')).toFixed(6));
      const lng = Number(parseFloat(geoLoc.longitude.replace(',', '.')).toFixed(6));
      if (charityId) {
        const activeCharity = activeCharities.find(activeCharity => activeCharity.charityId === charityId);
        setCharity(activeCharity);
      }
      setPinLocation({
        lat,
        lng
      });
      setLocationConfirmed(true);
      setLocationType(geoLocType);
      setLyckoplatsenName(geoLocName);
      svs.components.Storage.browser.remove('start', 'subscription');
    }
  }, []);
}
setGlobal('svs.lyckoplatsen.page_play.utils.useStorageWager', useStorageWager);

 })(window);